import api from '@/api'
import store from '@/store/store'

const app = {
  state: {
    games: [],
    appId: store.getAppId(),
    channels: [],
    dataPickerValue: [],
    channelId: 0,
    servers: [],
    serverId: 0
  },
  getters: {
    games: state => state.games,
    appId: state => state.appId,
    channels: state => state.channels,
    dataPickerValue: state => state.dataPickerValue,
    channelId: state => state.channelId,
    servers: state => state.servers,
    serverId: state => state.serverId
  },
  mutations: {
    SET_GAMES: (state, games) => {
      state.games = games
    },
    SET_APP_ID: (state, appId) => {
      state.appId = appId
    },
    SET_DATA_PICKER_VALUE: (state, dataPickerValue) => {
      state.dataPickerValue = dataPickerValue
    },
    SET_CHANNELS: (state, channels) => {
      state.channels = channels
      state.channelId = 0
    },
    SET_CHANNEL_ID: (state, channelId) => {
      state.channelId = channelId
    },
    SET_SERVERS: (state, servers) => {
      state.servers = servers
      state.serverId = 0
    },
    SET_SERVER_ID: (state, serverId) => {
      state.serverId = serverId
    }
  },
  actions: {
    GetGames ({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.gameList().then(res => {
          let games = []
          for (let d of res) {
            if (d.status === 0) {
              continue
            }
            games.push({value: d.id, text: d.id + '-' + d.name})
          }
          commit('SET_GAMES', games)
          if (games.length > 0) {
            let appId = games[games.length - 1].value
            commit('SET_APP_ID', appId)
            store.setAppId(appId)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ChangeGame ({ commit, state }, appId) {
      return new Promise((resolve, reject) => {
        api.channelList(appId).then(res => {
          let channels = [{value: 0, text: '0-全部'}]
          for (let c of res) {
            channels.push({value: c.channelId, text: c.channelId + '-' + c.channelName})
          }
          commit('SET_APP_ID', appId)
          commit('SET_CHANNELS', channels)
          store.setAppId(appId)
        })
        api.serverList(appId).then(res => {
          let servers = [{value: 0, text: '0-全部'}]
          for (let d of res.data) {
            servers.push({value: d.id, text: d.id + '-' + d.name})
          }
          commit('SET_SERVERS', servers)
        })
        resolve()
      })
    },
    ChangeDataPickerValue ({ commit, state }, dataPickerValue) {
      return new Promise((resolve, reject) => {
        commit('SET_DATA_PICKER_VALUE', dataPickerValue)
        resolve()
      })
    },
    ChangeChannelId ({ commit, state }, channelId) {
      return new Promise((resolve, reject) => {
        commit('SET_CHANNEL_ID', channelId)
        resolve()
      })
    },
    ChangeServerId ({ commit, state }, serverId) {
      return new Promise((resolve, reject) => {
        commit('SET_SERVER_ID', serverId)
        resolve()
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js